import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MøteRedigerTidspunktKontroller, MøteRedigerTidspunktKontrollerAvhengigheter, MøteRedigerTidspunktKontrollerAvhengigheter_DI_TOKEN, MøtetidspunktValideringsfeil} from "../../../møte/komponenter/møte-rediger-tidspunkt/møte-rediger-tidspunkt";
import {TypetValideringsresultatModell} from "felles-ng2/tjenester/ressurser/ng2HttpKlientTilleggstyper";
import {MøteRedigerDetaljerKontroller, MøteRedigerDetaljerSkjema} from "web-ng2/moduler/møte/komponenter/møte-rediger-detaljer/møte-rediger-detaljer";
import {ProtokollDetaljerModell, ProtokollSpesifikasjon} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {ZonedDateTimePeriodeLukket} from "felles-ng2/typer/ZonedDateTimePeriode";
import {Tidssoneinformasjon} from "felles-ng2/tjenester/i18n/GjeldendeTidssone";

const debug = initDebugger('MøteprotokollRedigerDetaljerKontroller');

/**
 * Skjema for redigering av protokollførte møtedetaljer.
 * Delegerer til {@link MøteRedigerDetaljerKontroller}.
 * Merk at MøteRedigerDetaljerKontroller ikke kan benyttes direkte i ajs-kode pga
 * forelder må injisere MøteRedigerTidspunktKontrollerAvhengigheter_DI_TOKEN,
 * av denne grunne trenger vi MøteprotokollRedigerDetaljerKontroller
 */
@Component({
    selector: 'moeteprotokoll-rediger-detaljer',
    templateUrl: './møteprotokoll-rediger-detaljer.html',
    styleUrls: ['./møteprotokoll-rediger-detaljer.scss'],
    providers: [
        {provide: MøteRedigerTidspunktKontrollerAvhengigheter_DI_TOKEN, useExisting: MøteprotokollRedigerDetaljerKontroller},
    ],
    imports: [
        MøteRedigerDetaljerKontroller
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MøteprotokollRedigerDetaljerKontroller implements MøteRedigerTidspunktKontrollerAvhengigheter {

    static opprettSkjema(): MøteRedigerDetaljerSkjema {
        return MøteRedigerDetaljerKontroller.opprettSkjema();
    }

    static populerSkjema(skjema: MøteRedigerDetaljerSkjema, protokoll: ProtokollDetaljerModell, tidssone: Tidssoneinformasjon) {
        skjema.patchValue({
            tidspunkt: MøteRedigerTidspunktKontroller.somSkjemaverdier(ZonedDateTimePeriodeLukket.les(protokoll.dato), tidssone.somZoneId()),
            behandlingsmaate: protokoll.behandlingsMaate,
            moetested: protokoll.behandlingsSted
        });
    }

    static gjenopprettSkjema(skjema: MøteRedigerDetaljerSkjema, skjemaverdier: ProtokollSpesifikasjon, tidssone: Tidssoneinformasjon) {
        skjema.patchValue({
            tidspunkt: MøteRedigerTidspunktKontroller.somSkjemaverdier(ZonedDateTimePeriodeLukket.les(skjemaverdier.dato), tidssone.somZoneId()),
            behandlingsmaate: skjemaverdier.behandlingsMaate,
            moetested: skjemaverdier.behandlingsSted
        });
    }

    @Input({required: true}) skjema!: MøteRedigerDetaljerSkjema;

    constructor() {
    }

    // MøteRedigerTidspunktKontrollerAvhengigheter impl

    validerMøtetidspunkt(møtedato: ZonedDateTimePeriodeLukket): Promise<TypetValideringsresultatModell<MøtetidspunktValideringsfeil>> {
        //ingen validering nødvendig - protokollført møtedato kan settes til hva som helst
        return Promise.resolve({harFeil: false, feil: []});
    }

    /** Ikke relevant ved redigering av møte */
    opprettNyÅrsplan(årstall: number): void {
    }

    // private hjelpemetoder

}
